/**
 * Chave do item Mensagens no menu. Ficou escondida no site publicado
 * até o Rick liberar para todos (14/10/2026, com 250/251 já no PROD).
 *
 * Desligada (false): no site publicado somem o item do menu, o número de não
 * lidas (que nem consulta o banco) e a aba da Auditoria; local aparece; um
 * navegador liga com localStorage.setItem('north:mensagens', '1').
 */
export const MENSAGENS_LIBERADAS = true;

export const mensagensVisiveis = (): boolean => {
  if (MENSAGENS_LIBERADAS || import.meta.env.DEV) return true;
  try {
    return window.localStorage.getItem('north:mensagens') === '1';
  } catch {
    return false;
  }
};
